var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPadlockUnbranded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.541 41.226"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15007"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 218",
    d: "M18.27 0A12.949 12.949 0 005.431 13.067v1.656H3.287A3.168 3.168 0 000 17.745v20.459a3.168 3.168 0 003.287 3.021h29.967a3.168 3.168 0 003.287-3.021V17.745a3.168 3.168 0 00-3.287-3.021h-2.145v-1.656A12.949 12.949 0 0018.27 0zm0 1.963a10.942 10.942 0 0110.864 11.1v1.656H7.407v-1.656a10.942 10.942 0 0110.864-11.1zM3.287 16.687h29.967a1.184 1.184 0 011.312 1.058v20.459a1.184 1.184 0 01-1.312 1.058H3.287a1.184 1.184 0 01-1.312-1.058V17.745a1.184 1.184 0 011.312-1.058zm14.984 5.4a3.46 3.46 0 00-3.457 3.435v4.908a3.457 3.457 0 006.913 0v-4.908a3.46 3.46 0 00-3.457-3.437zm0 1.963a1.453 1.453 0 011.481 1.472v4.908a1.482 1.482 0 01-2.963 0v-4.908a1.453 1.453 0 011.481-1.473z",
    fill: "currentColor"
  }))));
}

export default __webpack_public_path__ + "c83fbd399792bf127d677d5b8969585c.svg";
export { SvgPadlockUnbranded as ReactComponent };